import configBackground from 'scoreboard/dashboards/widgets/wob-background-menu'
import WidgetConfigMenu from 'scoreboard/dashboards/widgets/widget-config-menu'
import chartAccessoryLabel from 'scoreboard/dashboards/widgets/chart/config/config-chart-accessory-label'

const ChartColorLegendConfigMenu = WidgetConfigMenu.extend({
	label: 'charts.editColorLegend',

	allowDuplicate: false,
	allowDrilldown: false,

	initialize: function (opt) {
		WidgetConfigMenu.prototype.initialize.apply(this, arguments)
		this.chartWidget = opt.chartWidget
	},

	render: function() {
		WidgetConfigMenu.prototype.render.apply(this, arguments)

		return this
	},

	typeSpecificTargets: function () {
		const options = []
		options.push(chartAccessoryLabel(this, this.model,
			this.chartWidget.chart, 'charts.setLegendLabel'))
		options.push(configBackground(this.model.properties))
		return options
	}
})

export default ChartColorLegendConfigMenu
ChartColorLegendConfigMenu.__filename__ = 'dashboards/widgets/chart/config/chart-color-legend-config-menu.js'
